<template>
  <span class="bg-grey-3 h-3 w-3 rounded-full"></span>
</template>
